const MARKETS = Object.freeze({
  AE: { country: "United Arab Emirates", code: "AE", currency: "AED", symbol: "د.إ" },
  SA: { country: "Saudi Arabia", code: "SA", currency: "SAR", symbol: "ر.س." },
});

export function applyLandingMarket(browser) {
  if (!browser) return false;
  const url = new URL(browser.location.href);
  const code = url.searchParams.get("country");
  if (!Object.hasOwn(MARKETS, code)) return false;
  const market = MARKETS[code];
  try {
    browser.localStorage.setItem("userCurrency", JSON.stringify(market));
    browser.localStorage.setItem("country_code", code);
    browser.localStorage.setItem("country", market.country);
  } catch {
    return false;
  }
  // Consume the campaign preference once so later manual changes remain effective.
  url.searchParams.delete("country");
  browser.history.replaceState(browser.history.state, "", url.pathname + url.search + url.hash);
  return true;
}

// Run before Redux and API modules read the shopper's saved currency.
applyLandingMarket(typeof window === "undefined" ? null : window);
